<template>
  <el-table
    :data="vats"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'value', order: 'ascending'}"
  >
    <el-table-column
      prop="value"
      label="Érték"
      :formatter="valueFormat"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :vat="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      vats() {
        return this.$store.getters['vat/vats'];
      },

      loading() {
        return this.$store.getters['vat/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('vat/fetchAll');
    },

    methods: {
      valueFormat(row, column, cellValue, index) {
        return cellValue + '%';
      }
    }
  }
</script>
